<template>
  <div class="authentication-object-icon-table-cell">
    <div class='authentication-object-icon-table-cell__icon'>
      <v-icon>{{icon}}</v-icon>
    </div>
  </div>
</template>

<script>
import { AUTHENTICATION_OBJECT_TYPES } from '@/constants/authenticationObject';

export default {
  name: 'AuthenticationObjectIconTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      switch (this.item.type) {
      case AUTHENTICATION_OBJECT_TYPES.USER_PASSWORD:
        return 'password';
      case AUTHENTICATION_OBJECT_TYPES.AWS:
        return 'key';
      default:
        return 'password';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.authentication-object-icon-table-cell {
  font-family: $font-family-regular;
  font-size: rem(14);
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--text-tertiary);
  &__icon {
    max-width: rem(24) !important;
    display: flex;

    .v-icon {
      color: var(--text-tertiary);
    }
  }
}

</style>
